import { render, staticRenderFns } from "./baseNoticeModal.vue?vue&type=template&id=675c0e6c&"
import script from "./baseNoticeModal.vue?vue&type=script&lang=js&"
export * from "./baseNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./baseNoticeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports